// User types
export interface User {
  id: string;
  username: string;
  email: string;
  display_name: string | null;
  role: 'SuperAdmin' | 'Admin' | 'Employee';
  status: string;
  phone: string | null;
}

// Shift types
export interface Shift {
  id: string;
  date: string;
  start_time: string;
  end_time: string;
  status: 'Available' | 'Pending' | 'Assigned' | 'Deleted';
  assignment_type: 'Regular' | 'Permanent' | 'Admin';
  name: string | null;
  notes: string | null;
  deleted?: number; // 0 = not deleted, 1 = deleted (optional for backward compatibility)
  assigned_users: User[];
}

// Shift request types
export interface ShiftRequest {
  id: string;
  shift_id: string;
  user_id: string;
  status: 'Pending' | 'Approved' | 'Rejected';
  request_time: string;
  processed_at: string | null;
  processed_by: string | null;
  notes: string | null;
  shift: Shift;
  user: User;
}

// Permanent shift types
export interface PermanentShift {
  id: string;
  user_id: string;
  day_of_week: DayOfWeek;
  start_time: string;
  end_time: string;
  name: string | null;
  active: boolean;
}

// Shift swap types
export interface ShiftSwap {
  id: string;
  shift_id: string;
  requesting_user_id: string;
  target_user_id: string;
  status: 'Pending' | 'Accepted' | 'Rejected' | 'Cancelled';
  requested_at: string;
  responded_at: string | null;
  shift?: Shift;
  requesting_user?: User;
  target_user?: User;
}

// Shift drop request types
export interface ShiftDropRequest {
  id: string;
  shift_id: string;
  user_id: string;
  status: 'Pending' | 'Approved' | 'Rejected';
  request_time: string;
  processed_at: string | null;
  processed_by: string | null;
  notes: string | null;
  shift?: Shift;
  user?: User;
}

// Tenant (for showing which org you're in)
export interface TenantPublic {
  id: string;
  name: string;
  slug: string;
  status: string;
}

// Auth types
export interface AuthResponse {
  user: User;
  token: string;
  expiresAt: string;
}

// API response type
export interface ApiResponse<T = unknown> {
  success: boolean;
  data?: T;
  message?: string;
  error?: string;
}

// Shift time slot
export interface ShiftTimeSlot {
  start: string;
  end: string;
  label: string;
}

export const SHIFT_TIME_SLOTS: ShiftTimeSlot[] = [
  { start: '00:00', end: '06:00', label: 'Midnight - 6AM' },
  { start: '06:00', end: '09:00', label: '6AM - 9AM' },
  { start: '09:00', end: '12:00', label: '9AM - 12PM' },
  { start: '12:00', end: '15:00', label: '12PM - 3PM' },
  { start: '15:00', end: '18:00', label: '3PM - 6PM' },
  { start: '18:00', end: '21:00', label: '6PM - 9PM' },
  { start: '21:00', end: '00:00', label: '9PM - Midnight' }
];

export const DAYS_OF_WEEK = [
  'Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'
] as const;

export type DayOfWeek = typeof DAYS_OF_WEEK[number];
